import React from "react"
import styled from "styled-components"
import { Label } from "@jobintrans/base-ui.components.atoms.typography"
import { BaseStyles } from "@jobintrans/base-ui.types.base-styles"
import { common } from "@jobintrans/base-ui.components.atoms._atoms"

const List = ({
  list,
  ...rest
}: BaseStyles & {
  list: string[]
}) => {
  return (
    <Wrapper {...rest}>
      {list.map((el, index) => (
        <Label key={index} icon="check" $type="secondary">
          {el}
        </Label>
      ))}
    </Wrapper>
  )
}

export default List

const Wrapper = styled.div`
  ${common};

  > * {
    margin-bottom: 10px;
  }

  svg {
    color: ${({ theme }) => theme.color.primary};
  }
`
